// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"b0d9e63a","228":"abdb44da","351":"d2a2459c","382":"94b00bf2","439":"7a6bfd11","807":"05164838","817":"80ccd6ad","956":"6e32bc06","978":"3dc393bf"}[chunkId] + ".chunk.js";
};